export default "__VITE_ASSET__5OZUA2vE__"